module.exports = {"24":"24\"","28":"28\"","32":"32\"","36":"36\"","48":"48\"","60":"60\"","72+":"72\" or greater"}


//////////////////
// WEBPACK FOOTER
// ./src/config/flaskSize.json
// module id = 5682
// module chunks = 1